import { i18n as i18Next } from 'i18next'
import _ from 'lodash'
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'

import { matchRoute } from '../../hooks/useMatchRoute'
import { DISABLED_LOGIN_CALLBACK_ROUTES, RouteConfig } from '../../routes/routes'
import { apiCall } from '../../utils/api'
import { mapActionError } from '../../utils/helpers'
import { formatUrl } from '../../utils/routes'
import { SignalR } from '../../utils/signalr'
import { getCmsLoginUrl } from '../config/selectors'
import { LogActions } from '../logs/actions'
import { OrderActions } from '../order'
import { getCurrentLocationPath } from '../location/selector'

import { UserActions } from './actions'

export function* handleLogout(action: ReturnType<typeof UserActions.logout>) {
  const cmsLoginUrl: string = yield select(getCmsLoginUrl)

  const pathname: string = yield select(getCurrentLocationPath)
  const i18n: i18Next = yield getContext('i18n')
  const routes: RouteConfig = yield getContext('routes')

  const loginUrl = formatUrl(encodeURI(window.location.origin), encodeURI(cmsLoginUrl), {
    returnUrl: _.some(DISABLED_LOGIN_CALLBACK_ROUTES, x => !!matchRoute(routes, pathname, x, i18n.language, i18n))
      ? undefined
      : window.location.href
  })

  try {
    yield call(apiCall, {
      url: '/api/auth/logout',
      method: 'post',
      umbracoCall: true,
      withCredentials: true
    })

    yield put(
      UserActions.setToken({
        token: ''
      })
    )

    yield put(OrderActions.reset())
    yield call(SignalR.stop)
    sessionStorage.removeItem('isLoginAs')
    const { isLoginAsMode } = action.payload
    if (isLoginAsMode) {
      window.close()
    } else {
      window.location.href = loginUrl
    }
  } catch (e: any) {
    yield put(LogActions.addLogItem(mapActionError(e, 'ERROR', window.location.href)))
  }
}

export function* userSagas() {
  yield all([takeLatest(getType(UserActions.logout), handleLogout)])
}
